import { loadScript } from '../loadScript'
import config from '../config'

/**
 * Включение библиотеки admin-scripts
 */
const adminDrupal6Scripts = {
  state: {
    lib: config.DEVMODE ? ['js/_drupal-6-admin/adminScripts.js'] : [config.THEME + 'js/drupal-6-admin/adminScripts.js'],
    isActive: false
  },
  activate: function () {
    // Выйти, если повторный запуск интеграции jQuery
    if (this.state.isActive) {
      return
    }
    const path = '/admin/'
    if (window.location.pathname.indexOf(path, 0) !== 0) {
      return
    }
    loadScript(this.state.lib)
    this.state.isActive = true
  }
}
export default adminDrupal6Scripts
